'use client'

import React, { createContext, useContext } from 'react'

const SitePromoBannerVisibleContext = createContext(false)

export function SitePromoBannerVisibilityProvider({
  children,
  visible,
}: {
  children: React.ReactNode
  visible: boolean
}) {
  return (
    <SitePromoBannerVisibleContext.Provider value={visible}>
      {children}
    </SitePromoBannerVisibleContext.Provider>
  )
}

export function useSitePromoBannerVisible() {
  return useContext(SitePromoBannerVisibleContext)
}
